import { render, staticRenderFns } from "./widgetTags.vue?vue&type=template&id=ba8849d0&scoped=true"
import script from "./widgetTags.vue?vue&type=script&lang=js"
export * from "./widgetTags.vue?vue&type=script&lang=js"
import style0 from "./widgetTags.vue?vue&type=style&index=0&id=ba8849d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8849d0",
  null
  
)

export default component.exports